import 'flatpickr';
import 'dateformat'

export default {
  init(selector, config) {
  },
  finalize() {

    // hide course name and from and to divs on load
    $(".courseNameDiv").hide();
    $(".dateMainDiv").hide();

    //Initialize calendar for fromdate
    $("#fromDate").flatpickr({
      altInput: true,
      altFormat: "Y-m-d",
      dateFormat: "Y-m-d",
      maxDate: "today",
      onClose: function(selectedDates, dateStr, instance){
        const dateFormat = require('dateformat');
        const todayDate = dateFormat(new Date(), "yyyy-mm-dd");
        const fromDateformat = dateFormat(new Date(selectedDates), "yyyy-mm-dd");
        const fromDate = new Date(dateStr);
        const toDateMonth = new Date(fromDate.setMonth(fromDate.getMonth() + 2)); //add 2 month 
        const toFinalDate = dateFormat(toDateMonth, "yyyy-mm-dd");
        /* if fromdate not equal to currentdate  and less than current date*/
         if(fromDateformat != todayDate && toFinalDate <= todayDate ){
            FLATPICKER_TOCAL.setDate(toFinalDate); 
            FLATPICKER_TOCAL.set("maxDate", toFinalDate);
        } else{
            FLATPICKER_TOCAL.setDate(todayDate); 
            FLATPICKER_TOCAL.set("maxDate", todayDate);
        } 
        FLATPICKER_TOCAL.set("minDate", dateStr); //set same date
      }
    });

    //Initialize calendar for todate
    var FLATPICKER_TOCAL = flatpickr('#toDate', {
        altInput: true,
        altFormat: "Y-m-d",
        dateFormat: "Y-m-d",
        maxDate: "today",
    });

    // if REPORT TYPE change then hide/show dates div 
    $("#report_type").on('change', function(){
        var reportType = $(this).val();
        if (reportType !== ''){
            //removes red border from report type field when changing from default
            $("[data-id='report_type'].dropdown-toggle").attr('style', 'border: 1px solid #d5dae2 !important');
        }
        $(".courseNameDiv").hide(); // default courseName field hides
        $(".dateMainDiv").show(); // default fromdate and todate shows
        if(reportType  == "all_courses" || reportType  == "all_modules" ){
            $(".dateMainDiv").hide();
        }
        if(reportType == "enrolment_single_course"){
            $(".courseNameDiv").show();
        }
    });

    $("#course_module_name").on('change', function(){
        if ($(this).val() !== ''){
            $("[data-id='course_module_name'].dropdown-toggle").attr('style', 'border: 1px solid #d5dae2 !important');
        }
    })

    $("#download_report").on('click', function(){
       var reportType = $("#report_type").val(); //get report type value
       var fromDate = $("#fromDate").val(); // get the formDate value
       var toDate = $("#toDate").val(); // get the toDate value

        $(".dateMainDiv").show(); // default fromdate and todate shows
        $(".is-invalid").removeClass('is-invalid'); 
        $(".dropdown-toggle").attr('style', 'border: 1px solid #d5dae2 !important'); // removes red border by default

        if(reportType == ''){
            // adds red border when option is not picked
            $("[data-id='report_type'].dropdown-toggle").attr('style', 'border: 1px solid red !important');
            return false;
        }else{
            if(reportType  == "all_courses" || reportType  == "all_modules" ){
                $(".dateMainDiv").hide(); //hide dates class
            }
            else if(reportType == "enrolment_single_course"){
                if ($("#course_module_name").val() == ''){
                    // adds red border when option is not picked
                    $("[data-id='course_module_name'].dropdown-toggle").attr('style', 'border: 1px solid red !important');
                    return false;
                }
                if (fromDate !== '' && toDate === ''){
                    $(".todate").addClass('is-invalid');
                    return false;
                }
                if (fromDate === '' && toDate !== ''){
                    $(".fromdate").addClass('is-invalid');
                    return false;
                }
            }else{
                if(fromDate == ''){
                    $(".fromdate").addClass('is-invalid');
                    return false;
                }else if(toDate == ''){
                    $(".todate").addClass('is-invalid');
                    return false;
                }
            }  
        }

        //ajax call
         $("#loading_button").removeClass('d-none');
        $("#loading_button").show();
        $("#download_report").hide();
        var course_type = '';
        var enrolment_type = '';
        
        switch(reportType){
            case('all_users'):
                var url = ajaxdta.ajaxurl + "?action=get_user_info";
                var file_name = 'user-info ('+fromDate+' to '+toDate+').csv';
                break;
            case('all_courses'):
                var course_type = 'course';
                var url = ajaxdta.ajaxurl + "?action=get_online_course_data";
                var file_name = 'all-courses.csv';
                break;
            case('all_modules'):
                var course_type = 'module';
                var url = ajaxdta.ajaxurl + "?action=get_online_course_data";
                var file_name = 'all-modules.csv';
                break;
            case('enrolment_course'):
                var enrolment_type = 'course';
                var url = ajaxdta.ajaxurl + "?action=get_enrolment_data";
                var file_name = 'enrolment-data-course ('+fromDate+' to '+toDate+').csv';
                break;
            case('enrolment_module'):
                var enrolment_type = 'module';
                var url = ajaxdta.ajaxurl + "?action=get_enrolment_data";
                var file_name = 'enrolment-data-module ('+fromDate+' to '+toDate+').csv';
                break;
            case('user_survey_two'):
                var url = ajaxdta.ajaxurl + "?action=get_user_received_survey_two_data";
                var file_name = 'user-received-survey-two ('+fromDate+' to '+toDate+').csv';
                break;
            case('survey1_result'):
                var url = ajaxdta.ajaxurl + "?action=get_survey_one_results_csv";
                var file_name = 'survey_one_results_export ('+fromDate+' to '+toDate+').csv';
                break;
            case('survey2_result'):
                var url = ajaxdta.ajaxurl + "?action=get_survey_two_results_csv";
                var file_name = 'survey_two_results_export ('+fromDate+' to '+toDate+').csv';
                break;
            case('enrolment_single_course'):
                var course_id = $("#course_module_name").val();
                var course_title = $("#course_module_name option:selected").text();
                var url = ajaxdta.ajaxurl + "?action=get_single_course_enrolments_csv";
                var date_string = fromDate !== '' && toDate !== '' ? ` (${fromDate} to ${toDate}).csv`: '';
                var file_name = `${course_title.replace(" ", "_")}_enrolments${date_string}`;
                break;
            default:
                return;
        }
        
        $.ajax({
          type: "POST",
          url: url,
          data: {
            course_type: course_type,  
            enrolment_type: enrolment_type,
            fromDate:fromDate,
            toDate:toDate,
            courseId: course_id
          },
          success: function (res, status, xhr) {
            $("#loading_button").hide();
            $("#download_report").show();
            var csvData = new Blob([res], { type: "text/csv;charset=utf-8;" });
            var csvURL = window.URL.createObjectURL(csvData);
            var tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute("download", file_name);
            tempLink.click();
          },
        });
        //End Call
        

            
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/dta-reports.js